import { ThemePalette } from '@angular/material/core';

export class SidebarItem {
  link: string;
  icon: string | { name: string, font: string };
  label: string | { full: string, short: string };
  children: Array<SidebarItem> | Array<AdminSidebarItem> = [];
  overrideClick?: Function;
  class: string;

  selected = false;
  noSelect = false;
  noLink = false;
  divider = false;
  // Badges visuais (canto superior direito do botão). Cada badge tem uma
  // classe de status (mapeada a uma cor em CSS) e um número.
  badges?: Array<{
    statusClass: string,
    count: number,
    tooltip?: string,
    // Se presente, o badge vira um <a> clicável (independente do link do
    // próprio item). Ex.: badge de "convites pendentes" leva à página
    // /reviews já com o preset de filtro aplicado.
    link?: string,
    queryParams?: { [k: string]: string | number | boolean },
  }>;

  constructor(
    link: string,
    icon: string | { name: string, font: string },
    label: string | { full: string, short: string },
    extra?: {
      children?: Array<SidebarItem> | Array<AdminSidebarItem>,
      overrideClick?: Function,
      noSelect?: boolean,
      noLink?: boolean,
      class?: string,
      divider?: boolean
    }
  ) {
    this.link = link;
    this.icon = icon;
    this.label = label;

    if (extra) {
      this.children = extra.children;
      this.overrideClick = extra.overrideClick;
      this.class = extra.class;

      if (extra.noSelect) {
        this.noSelect = true;
      }

      if (extra.noLink) {
        this.noLink = true;
      }

      if (extra.divider) {
        this.divider = true;
      }
    }
  }

  get shouldRouterLink() {
    return !this.children;
  }
}

export class AdminSidebarItem {
  label: string;
  link: string;
  selected: boolean = false;
  icon?: string;

  constructor(
    label: string,
    link?: string,
    selected?: boolean,
    icon?: string
  ) {
    this.label = label;
    this.link = link;
    this.selected = selected;
    this.icon = icon;
  }
}
